import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";
import { IIPRestriction } from "./_types";

async function updateIPRestriction(
  data: IIPRestriction
): Promise<BaseResponse<null>> {
  try {
    return (await axiosInstance.put("/IPRestriction/Update", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateIPRestriction() {
  return useMutation<BaseResponse<null>, Error, IIPRestriction>(
    (variables) => updateIPRestriction(variables)
  );
}
